// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3C0V7","title":"Images45_title__3_cex","images":"Images45_images__SSJZT"};